import dayjs from 'dayjs';
import {
    licenseSettingsFulfilledConstants,
    licenseSettingsPendingConstants,
    licenseSettingsRejectedConstants
} from '../actions';
import { DATE_FORMAT } from '../utils';

const initialState = {
    dataPlanned: null,
    dataActual: null,
    loadingPlanned: true,
    loadingActual: true,
    errors: {
        errorPlanned: '',
        errorActual: '',
    },
};

export default function (state = initialState, action) {

    switch (action.type) {
        case licenseSettingsFulfilledConstants.LICENSE_SETTINGS_PLANNED_PAYMENTS_LOADED:
            const { startDate: plannedStartDate, endDate: plannedEndDate } = action.payload;
            const newPlannedStartDate = plannedStartDate ? dayjs(plannedStartDate, DATE_FORMAT) : null;
            const newPlannedEndDate = plannedEndDate ? dayjs(plannedEndDate, DATE_FORMAT) : null;

            return {
                ...state,
                dataPlanned: {
                    ...action.payload,
                    startDate: newPlannedStartDate,
                    endDate: newPlannedEndDate
                },
                loadingPlanned: false
            };

        case licenseSettingsFulfilledConstants.LICENSE_SETTINGS_ACTUAL_PAYMENTS_LOADED:
            const { startDate: actualStartDate, endDate: actualEndDate } = action.payload;
            const newActualStartDate = actualStartDate ? dayjs(actualStartDate, DATE_FORMAT) : null;
            const newActualEndDate = actualEndDate ? dayjs(actualEndDate, DATE_FORMAT) : null;

            return {
                ...state,
                dataActual: {
                    ...action.payload,
                    startDate: newActualStartDate,
                    endDate: newActualEndDate
                },
                loadingActual: false
            };

        case licenseSettingsFulfilledConstants.LICENSE_SETTINGS_PLANNED_PAYMENTS_CREATED:
            return {
                ...state,
                loadingPlanned: false
            };

        case licenseSettingsFulfilledConstants.LICENSE_SETTINGS_ACTUAL_PAYMENTS_CREATED:
            return {
                ...state,
                loadingActual: false
            };

        case licenseSettingsPendingConstants.LICENSE_SETTINGS_PLANNED_PAYMENTS_LOADED:
        case licenseSettingsPendingConstants.LICENSE_SETTINGS_PLANNED_PAYMENTS_CREATED:
            return {
                ...state,
                loadingPlanned: true
            };

        case licenseSettingsPendingConstants.LICENSE_SETTINGS_ACTUAL_PAYMENTS_LOADED:
        case licenseSettingsPendingConstants.LICENSE_SETTINGS_ACTUAL_PAYMENTS_CREATED:
            return {
                ...state,
                loadingActual: true
            };

        case licenseSettingsRejectedConstants.LICENSE_SETTINGS_PLANNED_PAYMENTS_LOADED:
        case licenseSettingsRejectedConstants.LICENSE_SETTINGS_PLANNED_PAYMENTS_CREATED:
        {
            const error = action.payload;
            const { response, message } = error ?? {};

            if (response || message) {
                return {
                    ...state,
                    loadingPlanned: false,
                    errors: {
                        ...state.errors,
                        errorPlanned: response.data || response.statusText ?
                            response.data.errorMessage || response.statusText : message
                    },
                };
            }
            return state;
        }

        case licenseSettingsRejectedConstants.LICENSE_SETTINGS_ACTUAL_PAYMENTS_LOADED:
        case licenseSettingsRejectedConstants.LICENSE_SETTINGS_ACTUAL_PAYMENTS_CREATED:
        {
            const error = action.payload;
            const { response, message } = error ?? {};

            if (response) {
                return {
                    ...state,
                    loadingActual: false,
                    errors: {
                        ...state.errors,
                        errorActual: response.data || response.statusText ?
                            response.data.errorMessage || response.statusText : message
                    },
                };
            }
            return state;
        }

        default:
            return state;
    }
}
